// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { FaCertificate } from 'react-icons/fa';
// import './Experience.css';

// const Experience = () => {
//   const [selectedCertificate, setSelectedCertificate] = useState(null);

//   const experiences = [
//     {
//       title: 'Web Developer Intern',
//       company: 'Olcademy',
//       certificate: 'olcademy.png',
//       description: 'Developed web applications and gained hands-on experience in frontend development.'
//     },
//     {
//       title: 'Full Stack Developer Intern',
//       company: 'Prasunet Pvt Ltd',
//       certificate: 'prasunet.png',
//       description: 'Worked on full-stack development projects, implementing both frontend and backend solutions.'
//     },
//     {
//       title: 'AI Intern',
//       company: 'Mirai School',
//       certificate: 'mirai_internship_certificate.jpeg',
//       description: 'Explored AI technologies and contributed to machine learning projects.'
//     }
//   ];

//   const openModal = (certificate) => {
//     setSelectedCertificate(certificate);
//   };

//   const closeModal = () => {
//     setSelectedCertificate(null);
//   };

//   return (
//     <section id="experience" className="experience">
//       <div className="container">
//         <motion.div
//           className="section-header"
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           viewport={{ once: true }}
//         >
//           <h2>Experience</h2>
//           <div className="underline"></div>
//         </motion.div>

//         <div className="experience-grid">
//           {experiences.map((exp, index) => (
//             <motion.div
//               key={exp.title}
//               className="experience-card"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: index * 0.2 }}
//               viewport={{ once: true }}
//               whileHover={{ scale: 1.05 }}
//             >
//               <div className="experience-header">
//                 <h3>{exp.title}</h3>
//                 <span className="company">{exp.company}</span>
//               </div>
//               <p className="experience-description">{exp.description}</p>
//               <button
//                 className="certificate-btn"
//                 onClick={() => openModal(exp.certificate)}
//               >
//                 <FaCertificate /> View Certificate
//               </button>
//             </motion.div>
//           ))}
//         </div>

//         {selectedCertificate && (
//           <motion.div
//             className="modal-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={closeModal}
//           >
//             <motion.div
//               className="modal-content"
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               exit={{ scale: 0.8, opacity: 0 }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <button className="close-btn" onClick={closeModal}>×</button>
//               <img src={`/${selectedCertificate}`} alt="Certificate" className="certificate-image" />
//             </motion.div>
//           </motion.div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default Experience;



import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCertificate, FaExternalLinkAlt } from 'react-icons/fa';
import './Experience.css';

const Experience = () => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const experiences = [
    {
      title: 'Web Developer Intern',
      company: 'Olcademy',
      certificate: 'olcademy.png',
      description: 'Worked on a web application contributing to both frontend and backend and fix many bugs '
    },
    {
      title: 'Full Stack Developer Intern',
      company: 'Prasunet Pvt Ltd',
      certificate: 'prasunet.png',
      description: 'Project based internship.Developed an AI-based logo generation, Implemented backend rate limiting'
    },
    {
      title: 'AI Intern',
      company: 'Mirai School',
      certificate: 'mirai_internship_certificate.jpeg',
      description: 'Worked with various  AI tools and technologies (like N8N ,ElevanLabs etc) '
    }
  ];

  const openModal = (certificate) => {
    setSelectedCertificate(certificate);
  };

  const closeModal = () => {
    setSelectedCertificate(null);
  };

  return (
    <section id="experience" className="experience">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Experience</h2>
          <div className="underline"></div>
        </motion.div>

        <div className="experience-grid">
          {experiences.map((exp, index) => (
            <motion.div
              key={exp.title}
              className="experience-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="experience-header">
                <h3>{exp.title}</h3>
                <span className="company">{exp.company}</span>
              </div>

              <p className="experience-description">
                {exp.description}
              </p>

              <button
                className="certificate-btn"
                onClick={() => openModal(exp.certificate)}
              >
               View Certificate
              </button>
            </motion.div>
          ))}
        </div>

        {selectedCertificate && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className="modal-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeModal}>
                ×
              </button>

              <img
                src={`/${selectedCertificate}`}
                alt="Certificate"
                className="certificate-image"
              />

              {/* Open in New Tab Button */}
              <a
                href={`/${selectedCertificate}`}
                target="_blank"
                rel="noopener noreferrer"
                className="open-tab-btn"
              >
                <FaExternalLinkAlt /> Open in New Tab
              </a>
            </motion.div>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Experience;